import { render, staticRenderFns } from "./cModalDevoluciones.vue?vue&type=template&id=0983d43c"
import script from "./cModalDevoluciones.vue?vue&type=script&lang=js"
export * from "./cModalDevoluciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports